import React, { useEffect, useMemo, useRef, useState } from 'react'
import styles from './ManagingTaskTypes.module.scss'
import ReactDOMServer from 'react-dom/server'
import InputWithIcon from 'components/CRM/UI/components/InputWithIcon/InputWithIcon'
import asideModalStore from 'Stores/asideModalStore'
import SectionSelectStyle from '../../ModalEbookSection/SectionSelectStyle/SectionSelectStyle'
import { superAxiosRequest } from 'axiosApi'
import FormField from 'components/UI/AsideModal/Form/FormField'
import { observer } from 'mobx-react'
import { VoiceRecognition } from 'components/CRM/UI/icons/iconComponents/VoiceRecognition'
import { Phone } from 'components/CRM/UI/icons/iconComponents/Phone'
import { Briefcase } from 'components/CRM/UI/icons/iconComponents/Briefcase'
import { AddCircle } from 'components/CRM/UI/icons/iconComponents/AddCircle'
import { CalendarCheck } from 'components/CRM/UI/icons/iconComponents/CalendarCheck'
import { KeyboardBox } from 'components/CRM/UI/icons/iconComponents/KeyboardBox'
import { Star } from 'components/CRM/UI/icons/iconComponents/Star'
import { Team } from 'components/CRM/UI/icons/iconComponents/Team'
import { Money } from 'components/CRM/UI/icons/iconComponents/Money'
import { Bookmark } from 'components/CRM/UI/icons/iconComponents/Bookmark'
import { TrashIcon } from 'components/CRM/UI/icons/iconComponents/TrashIcon'
import { ArrowLeft } from 'components/CRM/UI/icons/iconComponents/ArrowLeft'
import { ArrowRight } from 'components/CRM/UI/icons/iconComponents/ArrowRight'
import { Alarm } from 'components/CRM/UI/icons/iconComponents/Alarm'
import { CustomerService } from 'components/CRM/UI/icons/iconComponents/CustomerService'
import { Window } from 'components/CRM/UI/icons/iconComponents/Window'
import { ChatCheck } from 'components/CRM/UI/icons/iconComponents/ChatCheck'
import { Lock } from 'components/CRM/UI/icons/iconComponents/Lock'
import { Gift } from 'components/CRM/UI/icons/iconComponents/Gift'
import { BankCard } from 'components/CRM/UI/icons/iconComponents/BankCard'
import { Map } from 'components/CRM/UI/icons/iconComponents/Map'
import { MapTime } from 'components/CRM/UI/icons/iconComponents/MapTime'
import { MailAdd } from 'components/CRM/UI/icons/iconComponents/MailAdd'
import { Mail } from 'components/CRM/UI/icons/iconComponents/Mail'
import { Stack } from 'components/CRM/UI/icons/iconComponents/Stack'
import { File } from 'components/CRM/UI/icons/iconComponents/File'
import { FileEdit } from 'components/CRM/UI/icons/iconComponents/FileEdit'
import { FileCopy } from 'components/CRM/UI/icons/iconComponents/FileCopy'
import { MapPin2 } from 'components/CRM/UI/icons/iconComponents/MapPin2'
import { MapFill } from 'components/CRM/UI/icons/iconComponents/MapFill'
import { MicOff } from 'components/CRM/UI/icons/iconComponents/MicOff'
import { NotificationOff } from 'components/CRM/UI/icons/iconComponents/NotificationOff'
import { Key } from 'components/CRM/UI/icons/iconComponents/Key'
import { Alert } from 'components/CRM/UI/icons/iconComponents/Alert'
import { ArrowGoForward } from 'components/CRM/UI/icons/iconComponents/ArrowGoForward'
import { ArrowLeftUp } from 'components/CRM/UI/icons/iconComponents/ArrowLeftUp'
import { ArrowRightUp } from 'components/CRM/UI/icons/iconComponents/ArrowRightUp'
import { CheckboxMultiple } from 'components/CRM/UI/icons/iconComponents/CheckboxMultiple'
import { CloseCircle } from 'components/CRM/UI/icons/iconComponents/CloseCircle'
import { ErrorWarning } from 'components/CRM/UI/icons/iconComponents/ErrorWarning'
import { ExternalLink } from 'components/CRM/UI/icons/iconComponents/ExternalLink'
import { ThumbDown } from 'components/CRM/UI/icons/iconComponents/ThumbDown'
import { ThumbUp } from 'components/CRM/UI/icons/iconComponents/ThumbUp'
import { Home } from 'components/CRM/UI/icons/iconComponents/Home'
import { Government } from 'components/CRM/UI/icons/iconComponents/Government'
import { AtIcon } from 'components/CRM/UI/icons/iconComponents/AtIcon'
import { BarChart } from 'components/CRM/UI/icons/iconComponents/BarChart'
import { Reply } from 'components/CRM/UI/icons/iconComponents/Reply'
import { Slideshow } from 'components/CRM/UI/icons/iconComponents/Slideshow'
import { ChatVoice } from 'components/CRM/UI/icons/iconComponents/ChatVoice'
import { Pencil } from 'components/CRM/UI/icons/iconComponents/Pencil'
import { GitRepository } from 'components/CRM/UI/icons/iconComponents/GitRepository'
import { Folder } from 'components/CRM/UI/icons/iconComponents/Folder'
import { GiftIcon } from 'components/CRM/UI/icons/iconComponents/GiftIcon'
import { WaterFlash } from 'components/CRM/UI/icons/iconComponents/WaterFlash'
import { Goblet } from 'components/CRM/UI/icons/iconComponents/Goblet'
import { ChatDelete } from 'components/CRM/UI/icons/iconComponents/ChatDelete'

const icons = [
  { name: 'VoiceRecognition', component: VoiceRecognition },
  { name: 'ArrowLeft', component: ArrowLeft },
  { name: 'ArrowRight', component: ArrowRight },
  { name: 'CalendarCheck', component: CalendarCheck },
  { name: 'Alarm', component: Alarm },
  { name: 'CustomerService', component: CustomerService },
  { name: 'Window', component: Window },
  { name: 'ChatDelete', component: ChatDelete },
  { name: 'ChatCheck', component: ChatCheck },
  { name: 'Lock', component: Lock },
  { name: 'Gift', component: Gift },
  { name: 'Money', component: Money },
  { name: 'BankCard', component: BankCard },
  { name: 'Map', component: Map },
  { name: 'MapTime', component: MapTime },
  { name: 'MailAdd', component: MailAdd },
  { name: 'Mail', component: Mail },
  { name: 'Stack', component: Stack },
  { name: 'Phone', component: Phone },
  { name: 'KeyboardBox', component: KeyboardBox },
  { name: 'File', component: File },
  { name: 'FileEdit', component: FileEdit },
  { name: 'FileCopy', component: FileCopy },
  { name: 'MapPin2', component: MapPin2 },
  { name: 'MapFill', component: MapFill },
  { name: 'MicOff', component: MicOff },
  { name: 'NotificationOff', component: NotificationOff },
  { name: 'Key', component: Key },
  { name: 'AddCircle', component: AddCircle },
  { name: 'Alert', component: Alert },
  { name: 'ArrowLeftUp', component: ArrowLeftUp },
  { name: 'ArrowRightUp', component: ArrowRightUp },
  { name: 'ArrowGoForward', component: ArrowGoForward },
  { name: 'CheckboxMultiple', component: CheckboxMultiple },
  { name: 'CloseCircle', component: CloseCircle },
  { name: 'ErrorWarning', component: ErrorWarning },
  { name: 'ExternalLink', component: ExternalLink },
  { name: 'Star', component: Star },
  { name: 'ThumbDown', component: ThumbDown },
  { name: 'ThumbUp', component: ThumbUp },
  { name: 'Home', component: Home },
  { name: 'Government', component: Government },
  { name: 'AtIcon', component: AtIcon },
  { name: 'BarChart', component: BarChart },
  { name: 'Briefcase', component: Briefcase },
  { name: 'Bookmark', component: Bookmark },
  { name: 'Reply', component: Reply },
  { name: 'Slideshow', component: Slideshow },
  { name: 'ChatVoice', component: ChatVoice },
  { name: 'Pencil', component: Pencil },
  { name: 'GitRepository', component: GitRepository },
  { name: 'Folder', component: Folder },
  { name: 'GiftIcon', component: GiftIcon },
  { name: 'WaterFlash', component: WaterFlash },
  { name: 'Goblet', component: Goblet },
  // {name: 'PinDistance', component: PinDistance},
  // {name: 'TreasureMap', component: TreasureMap},
  { name: 'Team', component: Team },
]

const colorsForIcon = [
  {
    id: 1,
    background_color: '#FFF9E9',
    body_color: '#FFC700',
  },
  {
    id: 2,
    background_color: '#EAFFF8',
    body_color: '#1ABC97',
  },
  {
    id: 3,
    background_color: '#EAFCFF',
    body_color: '#1BE7FF',
  },
  {
    id: 4,
    background_color: '#FFE7EA',
    body_color: '#FF0022',
  },
  {
    id: 5,
    background_color: '#FDEFFC',
    body_color: '#C903FF',
  },
  {
    id: 6,
    background_color: '#EBFAFA',
    body_color: '#55B1F3',
  },
]

const ManagingTaskTypes = ({ translate }) => {
  const [selectedIcon, setSelectedIcon] = useState(icons[45])
  const [iconColor, setIconColor] = useState('#55b1f3')
  const [isOpenCustomTypeModal, setIsOpenCustomTypeModal] = useState(false)
  const [selectedTask, setSelectedTask] = useState(null)
  const [isIconSelected, setIsIconSelected] = useState(false)
  const [isColorSelected, setIsColorSelected] = useState(false)
  const customTypeContainerRef = useRef(null)
  const [colors, setColors] = useState(colorsForIcon)
  const { modalValues: values, changeValue, check } = asideModalStore
  const [candidateForUpdate, setCandidateForUpdate] = useState(null)
  const [taskTypes, setTaskTypes] = useState([])
  const inputRefs = useRef([])
  const [newTaskIcon, setNewTaskIcon] = useState(icons[45])
  const [newTaskIconColor, setNewTaskIconColor] = useState('#55b1f3')
  const [selectedTaskId, setSelectedTaskId] = useState(null)

  useEffect(() => {
    if (values.name && !isIconSelected && !isColorSelected) {
      const IconComponent = icons[45].component
      const svgString = ReactDOMServer.renderToStaticMarkup(
        <IconComponent fill={'#55b1f3'} />,
      )
      changeValue(
        `data:image/svg+xml,${encodeURIComponent(svgString)}`,
        'text_file',
      )
      changeValue(6, 'color')
      changeValue('Bookmark', 'description')
    }
  }, [values.name, isIconSelected, isColorSelected, changeValue])

  const removeTask = (index, taskId) => {
    superAxiosRequest({
      method: 'delete',
      link: `tasktracker/task_categories/${taskId}`,
      crm: true,
    })
      .then(() => {
        const newTasks = taskTypes.filter((task) => task.id !== taskId)
        setTaskTypes(newTasks)
      })
      .catch((error) => {
        console.error('Error deleting task:', error)
      })
  }

  const updateTaskName = (index, newName, taskId) => {
    setCandidateForUpdate({
      ...candidateForUpdate,
      [taskId]: {
        id: taskId,
        name: newName,
      },
    })
  }

  const updateTaskRequest = (taskId) => {
    if (candidateForUpdate && candidateForUpdate[taskId]) {
      const currentCandidate = candidateForUpdate[taskId]
      superAxiosRequest(
        {
          method: 'put',
          link: `tasktracker/task_categories/${currentCandidate?.id}`,
          crm: true,
        },
        { name: currentCandidate?.name },
      )
        .then((res) => {
          const updatedTasks = [...taskTypes]
          const updatedCandidate = updatedTasks?.find(
            (el) => el?.id === res?.data?.id,
          )
          updatedCandidate.name = currentCandidate?.name
          setTaskTypes(updatedTasks)
        })
        .catch((error) => {
          console.error('Error updating task name:', error)
        })
        .finally(() => {
          const newCandidateForUpdate = { ...candidateForUpdate }
          delete newCandidateForUpdate[taskId]
          setCandidateForUpdate(newCandidateForUpdate)
        })
    }
  }

  const updateIcon = (icon, color) => {
    const svgString = ReactDOMServer.renderToStaticMarkup(
      <icon.component fill={color} />,
    )
    const colorId = colorsForIcon.find((c) => c.body_color === color)?.id
    if (selectedTask && colorId !== undefined) {
      superAxiosRequest(
        {
          method: 'put',
          link: `tasktracker/task_categories/${selectedTask.id}`,
          crm: true,
        },
        {
          name: selectedTask.name,
          text_file: `data:image/svg+xml,${encodeURIComponent(svgString)}`,
          color: colorId,
          description: icon.name || '',
        },
      )
        .then((res) => {})
        .catch((error) => {})
    }
  }

  const updateColor = (color) => {
    if (selectedIcon) {
      const svgString = ReactDOMServer.renderToStaticMarkup(
        <selectedIcon.component fill={color} />,
      )
      const colorId = colorsForIcon.find((c) => c.body_color === color)?.id
      if (selectedTask && colorId !== undefined) {
        superAxiosRequest(
          {
            method: 'put',
            link: `tasktracker/task_categories/${selectedTask.id}`,
            crm: true,
          },
          {
            name: selectedTask.name,
            text_file: `data:image/svg+xml,${encodeURIComponent(svgString)}`,
            color: colorId,
          },
        )
          .then((res) => {})
          .catch((error) => {})
      }
    }
  }

  const handleIconClick = (icon) => {
    const svgString = ReactDOMServer.renderToStaticMarkup(
      <icon.component fill={iconColor || '#55b1f3'} />,
    )
    changeValue(
      `data:image/svg+xml,${encodeURIComponent(svgString)}`,
      'text_file',
    )
    changeValue(icon.name, 'description')

    setSelectedIcon(icon)
    setIsIconSelected(true)
    updateIcon(icon, iconColor)

    const updatedTasks = taskTypes.map((task) => {
      if (task.id === selectedTaskId) {
        return { ...task, icon: icon.component, color: iconColor }
      }
      return task
    })
    setTaskTypes(updatedTasks)

    if (selectedTaskId === 'new') {
      setNewTaskIcon(icon)
    }
  }

  const handleColorClick = (color) => {
    if (selectedIcon) {
      const svgString = ReactDOMServer.renderToStaticMarkup(
        <selectedIcon.component fill={color} />,
      )
      changeValue(
        `data:image/svg+xml,${encodeURIComponent(svgString)}`,
        'text_file',
      )
    }
    setIconColor(color)
    setIsColorSelected(true)
    updateColor(color)

    const updatedTasks = taskTypes.map((task) => {
      if (task.id === selectedTaskId) {
        return { ...task, color }
      }
      return task
    })
    setTaskTypes(updatedTasks)

    if (selectedTaskId === 'new') {
      setNewTaskIconColor(color)
    }
  }

  const getColorFromNumber = (number) => {
    const colorEntry = colorsForIcon.find((entry) => entry.id === number)
    if (colorEntry) {
      return colorEntry.body_color
    } else {
      return '#55b1f3'
    }
  }

  useEffect(() => {
    superAxiosRequest({
      method: 'get',
      link: 'tasktracker/task_categories',
      params: {
        limit: 100,
        offset: 0,
      },
      crm: true,
    })
      .then(({ data }) => {
        const mappedTaskTypes = data?.result?.map((item) => {
          const svgIcon = item?.text_file
          const iconColor = getColorFromNumber(item.color)
          return {
            id: item.id,
            name: item.name,
            icon: () => {
              if (svgIcon) return <img src={svgIcon} alt={item.name} />
              return <VoiceRecognition />
            },
            color: iconColor,
            isChangeable: true,
            description: item.description || '',
          }
        })
        setTaskTypes(mappedTaskTypes)
      })
      .catch(() => {})
  }, [])

  const openCustomTypeModal = (task) => {
    setSelectedTask(task)
    setSelectedTaskId(task.id)
    const currentIcon = icons.find((icon) => icon.name === task?.description)
    setSelectedIcon(currentIcon || icons[45])
    setIconColor(task.color)
    setIsOpenCustomTypeModal(true)
  }

  const closeCustomTypeModal = () => {
    setIsOpenCustomTypeModal(false)
    setSelectedTask(null)
    setSelectedTaskId(null)
  }

  return (
    <div className={styles.formContainer}>
      {taskTypes.map((el, index) => {
        let value = candidateForUpdate?.[el?.id]?.name || el?.name
        if (candidateForUpdate?.[el?.id]?.name === '')
          value = candidateForUpdate?.[el?.id]?.name
        return (
          <React.Fragment key={el.id}>
            <div className={styles.typeItem}>
              <InputWithIcon
                value={value}
                iconColor={el.color}
                onBlur={() => updateTaskRequest(el?.id)} // Добавляем onBlur
                onChange={(e) => updateTaskName(index, e.target.value, el?.id)}
                ref={(ref) => (inputRefs.current[el.id] = ref)}
              >
                <div
                  onClick={() => {
                    if (isOpenCustomTypeModal && selectedTaskId === el.id) {
                      closeCustomTypeModal()
                    } else {
                      openCustomTypeModal(el)
                    }
                  }}
                >
                  <el.icon />
                </div>
              </InputWithIcon>
              <div
                className={styles.trashBlock}
                onClick={() => removeTask(index, el.id)}
              >
                <TrashIcon fill={'#DFE6E9'} className={styles.trashIcon} />
              </div>
            </div>
            {isOpenCustomTypeModal && selectedTaskId === el.id && (
              <div
                className={styles.customTaskTypeContainer}
                ref={customTypeContainerRef}
              >
                <div className={styles.iconsBlock}>
                  {icons.map((icon, index) => {
                    const IconComponent = icon.component
                    return (
                      <div
                        key={`${Date.now()}_${index}`}
                        onClick={() => handleIconClick(icon)}
                      >
                        <IconComponent
                          fill={selectedIcon === icon ? iconColor : undefined}
                        />
                      </div>
                    )
                  })}
                </div>

                <div className={styles.colorPickerBlock}>
                  <div className={styles.title}>{translate.color_icons}:</div>
                  <SectionSelectStyle
                    isError={check('color')}
                    colors={colors}
                    changeValue={changeValue}
                    value={
                      colors.find((c) => c.body_color === iconColor)?.id ||
                      values.color
                    }
                    setIconColor={handleColorClick}
                    forceIdSix
                  />
                </div>
              </div>
            )}
          </React.Fragment>
        )
      })}

      <FormField>
        <InputWithIcon
          placeholder={translate?.your_task_type}
          value={values?.name || ''}
          iconColor={newTaskIconColor}
          onChange={(e) => changeValue(e.target.value, 'name')}
          isError={check('name')}
          ref={(ref) => (inputRefs.current['new'] = ref)}
        >
          <div
            onClick={() => {
              if (isOpenCustomTypeModal && selectedTaskId === 'new') {
                closeCustomTypeModal()
              } else {
                setSelectedTaskId('new')
                setIsOpenCustomTypeModal(!isOpenCustomTypeModal)
              }
            }}
          >
            {useMemo(
              () => (
                <newTaskIcon.component fill={newTaskIconColor} />
              ),
              [newTaskIcon, newTaskIconColor],
            )}
          </div>
        </InputWithIcon>
      </FormField>

      {isOpenCustomTypeModal && selectedTaskId === 'new' && (
        <div
          className={styles.customTaskTypeContainer}
          ref={customTypeContainerRef}
        >
          <div className={styles.iconsBlock}>
            {icons.map((icon, index) => {
              const IconComponent = icon.component
              return (
                <div
                  key={`${Date.now()}_${index}`}
                  onClick={() => handleIconClick(icon)}
                >
                  <IconComponent
                    fill={selectedIcon === icon ? iconColor : undefined}
                  />
                </div>
              )
            })}
          </div>

          <div className={styles.colorPickerBlock}>
            <div className={styles.title}>{translate?.color_icons}:</div>
            <SectionSelectStyle
              isError={check('color')}
              colors={colors}
              changeValue={changeValue}
              value={
                colors.find((c) => c.body_color === iconColor)?.id ||
                values.color
              }
              setIconColor={handleColorClick}
              forceIdSix
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default observer(ManagingTaskTypes)
